import axios from 'axios';
import type {AxiosResponse} from 'axios';
import {IFavoriteApi} from '@/common/scripts/types/favorites';
import type {IObserver} from '@/common/scripts/types/observer';
import Observer from '@/common/scripts/observer';

const observer: IObserver = new Observer();
const CLASS_ACTIVE = 'is-active';

const initFlatPageButtons = (favoriteButton: HTMLElement): void => {
    if (!favoriteButton) {
        return;
    }

    favoriteButton.addEventListener('click', () => {
        const state = favoriteButton.dataset['state'] === 'true';
        const premisesID = favoriteButton.dataset['id'] || null;
        const url = state ? IFavoriteApi.remove : IFavoriteApi.add;

        // Добавляем или удаляем предмет из избранного
        axios.post(url, {id: premisesID})
            .then((response: AxiosResponse) => {
                observer.publish('premisesFavorite', response.data.data?.quantity || null);

                favoriteButton.classList.toggle(CLASS_ACTIVE);
                favoriteButton.dataset['state'] = String(!state);
            });
    });
};

export default initFlatPageButtons;
